export default {
  "articles": "文章管理",
  "search": "搜索",
  "refresh": "刷新",
  "add": "添加",
  "importWeChatArticles": "导入公众号文章",
  "noArticlesYet": "暂无文章",
  "categories": "文章分类",
  "articleTitle": "文章标题",
  "articleType": "文章类型",
  "text": "文本",
  "link": "链接",
  "weChatArticle": "公众号文章",
  "publisher": "发布人",
  "coverImage": "封面图片",
  "status": "状态",
  "visible": "显示",
  "hidden": "隐藏",
  "order": "排序",
  "publishedAt": "发布时间",
  "actions": "操作",
  "editArticle": "编辑文章",
  "addArticle": "添加文章",
  "category": "选择分类",
  "pleaseSelectACategory": "请选择分类",
  "enterThePublisherName": "请填写发布人",
  "cover": "封面",
  "uploading": "上传中…",
  "uploadCover": "上传封面",
  "remove": "移除",
  "copyOrPasteACoverImageURL": "封面图片地址，可复制或粘贴",
  "weChatArticleURL": "公众号链接",
  "destinationURL": "跳转链接",
  "views": "阅读数",
  "selectDateAndTime": "选择日期时间",
  "content": "内容",
  "enterArticleContent": "请输入文章内容",
  "attachment": "附件",
  "attachmentURL": "附件地址",
  "upload": "上传",
  "oK": "确定",
  "coverPreview": "封面预览",
  "articleCover": "文章封面",
  "all": "全部",
  "selectAnArticleType": "请选择文章类型",
  "enterAnArticleTitle": "请填写文章标题",
  "enterADestinationURL": "请填写跳转链接",
  "pleaseSelectAStatus": "请选择状态",
  "couldNotUploadContentImage": "正文图片上传失败",
  "couldNotLoadData": "加载失败",
  "couldNotLoadCategories": "分类加载失败",
  "uploadFailed": "上传失败",
  "coverUploaded": "封面已上传",
  "couldNotUploadCover": "封面上传失败",
  "attachmentUploaded": "附件已上传",
  "couldNotUploadAttachment": "附件上传失败",
  "articleUpdated": "文章已更新",
  "articleCreated": "文章已创建",
  "couldNotSaveChanges": "保存失败",
  "deleteArticle": "确认删除文章「{p0}」？",
  "deleteArticle060": "删除文章",
  "deleted": "已删除",
  "couldNotDelete": "删除失败",
  "noCategoriesYet": "暂无分类",
  "categoryName": "分类名称",
  "edit": "编辑",
  "pleaseEnterACategoryName": "请输入分类名称",
  "enterACategoryName": "请填写分类名称",
  "categoryUpdated": "分类已更新",
  "categoryCreated": "分类已创建",
  "deleteCategory": "确认删除分类「{p0}」？",
  "deleteCategory071": "删除分类",
  "readLinks": "链接读取",
  "manualImport": "手动导入",
  "articleLinks": "文章链接",
  "oneLinkPerLineUpTo5": "每行一条，最多 5 条",
  "openAWeChatArticleChooseCopyLink": "打开公众号文章，点击右上角“复制链接”，粘贴到下方。",
  "pasteWeChatArticleLinksEGHttps": "粘贴公众号文章链接，例如 https://mp.weixin.qq.com/s/…",
  "afterReadingYouCanAddOrEdit": "读取后可手动补充或修改标题、封面。",
  "readArticleInformation": "读取文章信息",
  "openWeChatAccountSettings": "前往公众号设置",
  "confirmArticleInformation": "确认文章信息",
  "selectArticle": "选择第 {p0} 篇文章",
  "noCover": "暂无封面",
  "viewOriginal": "查看原文",
  "imported": "已导入",
  "delete": "删除",
  "httpsMpWeixinQqComSRequired": "https://mp.weixin.qq.com/s/…（必填）",
  "title": "标题",
  "articleTitleRequired": "文章标题（必填）",
  "coverImageURLOptional": "封面图片地址（选填）",
  "importCategory": "导入分类",
  "selectAnArticleCategory": "请选择文章分类",
  "noCategoriesAvailableAddACategoryAnd": "暂无可用分类，请先在文章分类中添加并设为显示。",
  "previouslyImportedArticlesWillBeSkipped": "· 已导入的文章将自动跳过",
  "cancel": "取消",
  "couldNotLoadDataTryAgainLater": "加载失败，请稍后重试",
  "enter1To5ArticleLinksOne": "请填写 1 至 5 条文章链接，每行一条",
  "couldNotReadArticlesTryAgainLater": "读取失败，请稍后重试",
  "enterATitleForEachSelectedArticle": "请填写所选文章的标题",
  "enterAValidWeChatURLForEach": "请填写所选文章的有效公众号链接",
  "importFailedCheckTheArticleInformation": "导入失败，请检查文章信息",
  "recordRange": "显示第 {from} 到第 {to} 条记录，总共 {total} 条记录",
  "articleCount": "{count} 篇",
  "publisherCaption": "发布人：{name}",
  "articleNumber": "文章 {number}",
  "addArticleCount": "添加文章（{count}/5）",
  "selectedCount": "已选 {count} 篇",
  "confirmImportCount": "确认导入（{count}）",
  "importResult": "已导入 {count} 篇文章",
  "importResultWithSkipped": "已导入 {count} 篇文章，跳过 {skipped} 篇已存在文章",
  "accountNotConfigured": "请先在公众号设置中填写公众号名称，用作文章发布人",
  "invalidWeChatLink": "请填写 mp.weixin.qq.com 的公众号文章链接",
  "incompleteWeChatLink": "文章链接不完整，请使用微信“复制链接”取得原文链接",
  "previewBusy": "文章读取服务繁忙，请稍后重试",
  "previewTimedOut": "本次读取已超时，请手动填写或稍后重新读取",
  "metadataUnavailable": "微信未返回可读取的文章信息，请手动填写标题和封面",
  "coverUnavailable": "未能读取封面，可手动填写图片地址",
  "wechatVerificationRequired": "微信要求访问验证，暂时无法读取，请手动填写标题和封面",
  "metadataReadFailed": "文章信息读取失败，请手动填写标题和封面",
  "backToList": "返回列表",
  "previewBusyForAssociation": "本协会正在读取文章，请稍后重试",
  "importBusy": "本协会正在导入文章，请稍后重试",
  "selectionExpired": "文章列表已过期或公众号配置已变更，请刷新列表后重新选择",
  "accountConfigurationChanged": "公众号配置已变更，请重新获取文章",
  "categoryUnavailable": "所选分类不存在或已隐藏，请重新选择"
}
